import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { settingActions, settingObj } from '../store/SettingSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import * as JSTool from '../store/JSTool';

import TitleView from '../component/TitleView';

export default function Page2_2(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const settingData = useSelector(state => state.settingData);
    const awardAryy = [
        'Avatar Frame x 1 <br/>Coins x 7777',
        'Basic Ascension Select Pack x 10 <br/>Draw Ticket  x 1<br/>Coins x 7777',
        'Excellent EXP Stone x 5 <br/>Draw Ticket x 2<br/>Coins x 7777',
        'Advanced Gift x 5 <br/>Draw Ticket x 3<br/>Coins x 7777',
        'Gourmet Platter x 1 <br/>Draw Ticket x 4<br/>Coins x 7777',
    ];

    React.useEffect(() => {

    }, []);

    return (
        <Stack
            id={props.anchorId}
            sx={{
                width: 1,
                height: settingData.innerHeight,
                alignItems: 'center',
                position: 'relative',
            }}>

            <Box
                component={'img'}
                src={JSTool.getImgPath('bg/bg_2.png')}
                sx={{
                    width: 1,
                    height: settingData.innerHeight,
                    objectFit: 'cover',
                    zIndex: 1,
                    position: 'absolute',
                }} />

            <Stack sx={{
                alignItems: 'center',
                height: settingData.innerHeight,
                justifyContent: 'center',
                zIndex: 2,
            }}>

                <TitleView title='PRE-REGISTRATION MILESTONES' mt={'60rem'} />

                <Stack sx={{
                    position: 'relative',
                    flexDirection: 'row',
                    zIndex: 0,
                    mt: '80rem',
                }}>
                    <Item imgName='10W' num='100,000' msg={awardAryy[0]} isDone={true} />
                    <Item imgName='20W' num='300,000' msg={awardAryy[1]} isDone={true} isUp={true} />
                    <Item imgName='30W' num='500,000' msg={awardAryy[2]} isDone={true}/>
                    <Item imgName='50W' num='800,000' msg={awardAryy[3]} isDone={true} isUp={true} />
                    <Item imgName='60W' num='1,000,000' msg={awardAryy[4]} />
                </Stack>


            </Stack>

        </Stack>
    );
}


function Item(props) {
    return (
        <Stack sx={{
            alignItems: 'center',
            zIndex: 2,
            mr: props.isUp ? -7 : -4,
            mt: props.isUp ? -4 : 4,
            px: 1,
            opacity: props.isDone ? 0.75 : 1,
        }}>
            <MoneyView num={props.num} isDone={props.isDone} />

            <Box component={'img'}
                src={props.isDone ? JSTool.getImgPath(`${props.imgName}_done.png`) : JSTool.getImgPath(`${props.imgName}.png`)}
                sx={{
                    my: 1,
                    width: '240rem',
                }} />

            <InfoView msg={props.msg} />
        </Stack>
    );
}

function MoneyView(props) {
    return (
        <Stack sx={{
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1,
            position: 'relative',
            flexDirection: 'row',
            height: '50rem',
            ml: 10,
        }}>
            <Stack sx={{
                position: 'absolute',
                flexDirection: 'row',
                height: 1,
                width: 1,
                top: 0,
                left: 0,
                justifyContent: 'center',
                zIndex: 1,
            }}>

                <Box sx={{
                    width: '45rem',
                    background: 'linear-gradient(90deg, #00000000 , #000000bb)',
                }} />
                <Box sx={{
                    flex: 1,
                    background: '#000000bb',
                }} />
                <Box sx={{
                    width: '45rem',
                    background: 'linear-gradient(-90deg, #00000000 , #000000bb)',
                }} />
            </Stack>

            <Typography
                sx={{
                    px: 3,
                    zIndex: 2,
                    width: 1,
                    height: 1,
                    lineHeight: '50rem',
                    textAlign: 'center',
                    fontSize: '30rem',
                    color: '#D0D9FE',
                    fontFamily: window.font0,
                    fontStyle: 'italic',
                }}>
                {props.num}
            </Typography>

            <Box component={'img'}
                src={JSTool.getImgPath('done.png')}
                sx={{
                    position: 'absolute',
                    height: 1,
                    zIndex: 3,
                    display: props.isDone ? 'block' : 'none',
                }} />
        </Stack>
    );
}


function InfoView(props) {
    return (
        <Stack sx={{
            alignItems: 'center',
            zIndex: 1,
            position: 'relative',
            flexDirection: 'row',
            ml: -10,
        }}>
            <Stack sx={{
                position: 'absolute',
                flexDirection: 'row',
                height: 1,
                width: 1,
                top: 0,
                left: 0,
                justifyContent: 'center',
                zIndex: 1,
            }}>

                <Box sx={{
                    width: '45rem',
                    background: 'linear-gradient(90deg, #00000000 , #000000bb)',
                }} />
                <Box sx={{
                    flex: 1,
                    background: '#000000bb',
                }} />
                <Box sx={{
                    width: '45rem',
                    background: 'linear-gradient(-90deg, #00000000 , #000000bb)',
                }} />
            </Stack>

            <Box
                component={'div'}
                sx={{
                    textAlign: 'center',
                    color: '#FFFFFFdd',
                    fontSize: '11rem',
                    px: 1.5,
                    py: 0.6,
                    fontWeight: 'bold',
                    zIndex: 2,
                    fontSize: '14rem',
                    fontFamily: window.font0,
                    fontStyle: 'italic',
                }}
                dangerouslySetInnerHTML={{
                    __html:
                        props.msg
                }} />
        </Stack>
    );
}